// extracted by mini-css-extract-plugin
export default {"root":"LandingPage_root__YsanD","rootPublic":"LandingPage_rootPublic__-DlNH LandingPage_root__YsanD"};